var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHvac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HVAC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M18.5,14.54V47.82a13,13,0,0,0,13,13h62.6a13,13,0,0,0,13-13V14.54ZM45.63,54.9V50.16a3.05,3.05,0,0,1,3.15-2.95H76.89A3.05,3.05,0,0,1,80,50.16V54.9Zm55.59-9.37a9.37,9.37,0,0,1-9.38,9.37H86.66V49.55c0-4.72-4.08-8.54-9.12-8.54H48.13c-5,0-9.12,3.82-9.12,8.54V54.9H33.83a9.36,9.36,0,0,1-9.37-9.37v-25h76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M42.68,115c-.93-.23-9.22-2.49-11.8-9.39-1.58-4.25-.61-8.94,2.9-13.94l.2-.27c2.27-2.73,4.79-6.62,3.89-9.71-.84-2.9-4.62-4.69-6-5.13L34.22,69c.92.29,9,3,11.26,10.43,1.53,5.15-.25,10.85-5.29,16.95-1.29,1.87-2.62,4.47-1.87,6.48,1,2.65,5.21,4.2,6.29,4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M66.5,115c-.93-.23-9.22-2.49-11.8-9.39-1.58-4.25-.61-8.94,2.9-13.94l.2-.27c2.27-2.73,4.79-6.62,3.9-9.71-.85-2.9-4.62-4.69-6-5.13L58.05,69c.92.29,9,3,11.25,10.43,1.53,5.15-.25,10.85-5.29,16.95-1.29,1.87-2.62,4.47-1.87,6.48,1,2.65,5.21,4.2,6.29,4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M90.33,115c-.94-.23-9.22-2.49-11.8-9.39-1.59-4.25-.62-8.94,2.89-13.94l.2-.27c2.28-2.73,4.8-6.62,3.9-9.71-.85-2.9-4.62-4.69-6-5.13L81.87,69c.92.29,9,3,11.25,10.43,1.53,5.15-.25,10.85-5.28,16.95-1.3,1.87-2.62,4.47-1.88,6.48,1,2.65,5.22,4.2,6.29,4.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/hvac.cb395876a284802847f003874e733a28.svg";
export { ForwardRef as ReactComponent };